import { render, staticRenderFns } from "./NewBranchAdd.vue?vue&type=template&id=323b7fba&scoped=true"
import script from "./NewBranchAdd.vue?vue&type=script&lang=js"
export * from "./NewBranchAdd.vue?vue&type=script&lang=js"
import style0 from "./NewBranchAdd.vue?vue&type=style&index=0&id=323b7fba&prod&lang=scss&scoped=true"
import style1 from "./NewBranchAdd.vue?vue&type=style&index=1&id=323b7fba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323b7fba",
  null
  
)

export default component.exports